import { API_URL } from "../../constants/pathConstants"
import { instructorStateData } from "../../data/instructorStateData"
import { InstructorProfileDataResponse } from "../types"

class InstructorProfileConnector {
	requestInProgress: boolean = false

	public async getInstructorProfileRequest(instructorId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InstructorProfileConnector] getInstructorProfileRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("instructorId", instructorId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				// headers.append('Access-Control-Allow-Origin', '*');
				// headers.append('Access-Control-Allow-Credentials', 'true');

				// headers.append('GET','POST');
				// headers.append('GET', 'POST', 'OPTIONS');

				// headers.append('Authorization', 'Basic ' + base64.encode(username + ":" + password));

				await fetch(`${API_URL}get-instructor-profile-data?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data: InstructorProfileDataResponse) => {
						console.log(data)
						if (data.profileData) {
							instructorStateData.profileData = data.profileData

						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InstructorProfileConnector] - getInstructorProfileRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const instructorProfileConnector: InstructorProfileConnector = new InstructorProfileConnector()